// removed by extract-text-webpack-plugin
module.exports = {"legal":"Legal__legal","modal":"Legal__modal","cta":"Legal__cta","highlight":"Legal__highlight","anchorClass":"Legal__anchorClass"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/atoms/Legal/Legal.css
// module id = 527
// module chunks = 8